import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AFEntity, SignInModel } from '../model/af.model';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-forgot-password-otp',
  templateUrl: './forgot-password-otp.component.html',
  styleUrls: ['./forgot-password-otp.component.scss']
})
export class ForgotPasswordOTPComponent implements OnInit {
  user: AFEntity;
  formModel: SignInModel;
  showWarning: boolean = false;

  form = this.fb.group({
    userName: [''],
    otpPassword: ['', [Validators.required, Validators.minLength(6)]]
  });

  constructor(private userService: AuthService, private fb: UntypedFormBuilder, private router: Router) {
  }

  ngOnInit() {
    this.user = this.userService.getUser();

    this.userService.forgotPasswordOTP().subscribe({
      next: (data: SignInModel) => {
        if (data) {
          this.formModel = data;
          this.showWarning = (data.warningMessage ? true : false);
        }
      },
      error: (error: any) => console.log(error)
    });
  }

  get otpPassword() { return this.form.get('otpPassword') };
  get userName() { return this.form.get('userName') };

  onSubmit() {
    let signInModel = new SignInModel();
    signInModel.verifyId = this.userService.getVerifyId();
    signInModel.username = this.user.email;
    signInModel.password = this.form.get("otpPassword").value;

    this.userService.validateOTP(signInModel).subscribe({
      next: (data: SignInModel) => {
        if (data) {
          this.formModel = data;

          if (!data.errorMessage && !data.warningMessage) {
            sessionStorage.setItem('maxCredential', "10");
            this.router.navigate(['resetPassword']);
          }
          if (data.errorMessage) {
            this.form.get('otpPassword').setErrors({ submitError: true });
          }
          this.showWarning = (data.warningMessage ? true : false);
        }
      },
      error: (error: any) => console.log(error)
    });
  }
}
